import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./NavItem.module.scss";
import Icon from "../../ui/Icon/Icon";

type Props = {
  to: string;
  icon: string;
  label: string;
  end?: boolean;
  disabled?: boolean;
  comingSoonLabel?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  ariaExpanded?: boolean;
  rightIcon?: string;
};

function NavItem({
  to,
  icon,
  label,
  end,
  disabled,
  comingSoonLabel,
  onClick,
  ariaExpanded,
  rightIcon,
}: Props) {
  if (disabled) {
    return (
      <div className={classNames(styles.item, styles.disabled)}>
        <Icon name={icon} className={styles.icon} />
        <span className={styles.label}>{label}</span>
        <span className={styles.pill}>{comingSoonLabel ?? "Soon"}</span>
      </div>
    );
  }

  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        classNames(styles.item, { [styles.active]: isActive })
      }
      onClick={onClick}
      aria-expanded={ariaExpanded}
    >
      <Icon name={icon} className={styles.icon} />
      <span className={styles.label}>{label}</span>
      {rightIcon && (
        <Icon
          name={rightIcon}
          className={classNames(styles.icon, styles.rightIcon, {
            [styles.rightIconExpanded]: ariaExpanded,
          })}
        />
      )}
    </NavLink>
  );
}

export default NavItem;
